if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        if (!window.__allowModalClose) return;
        super.hide();
      }
      
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const allMedia = this.querySelectorAll('[data-media-id]');
        const clickedMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${clickedMediaId}"]`);

        allMedia.forEach((element) => {
          if (element.getAttribute('data-media-id') === clickedMediaId) {
            element.classList.add('active');
            element.style.display = 'block';
          } else {
            element.classList.remove('active');
            element.style.display = 'none';
          }
        });

        if (activeMedia) {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}

/* =========================
   MODAL LOCK LOGIC (FINAL)
========================= */

// (function () {
//   const modalSelector = 'product-modal';
//   let observer = null;

//   window.__allowModalClose = false;

//   function lockModal(modal) {
//     if (!modal) return;

//     if (!modal.hasAttribute('open') && !window.__allowModalClose) {
//       modal.setAttribute('open', '');
//     }
//   }

//   function startObserver(modal) {
//     if (observer) observer.disconnect();

//     observer = new MutationObserver(() => {
//       if (!modal) return;

//       if (!modal.hasAttribute('open') && window.__allowModalClose) {
//         window.__allowModalClose = false;
//         observer.disconnect();
//         return;
//       }

//       lockModal(modal);
//     });

//     observer.observe(modal, {
//       attributes: true,
//       attributeFilter: ['open']
//     });
//   }

//   // Open modal → activate lock
//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('[data-media-id]')) return;

//     const modal = document.querySelector(modalSelector);
//     if (!modal) return;

//     setTimeout(() => {
//       startObserver(modal);
//       lockModal(modal);
//     }, 0);
//   });

//   // Allow close ONLY via close button
//   document.addEventListener(
//     'pointerdown',
//     (e) => {
//       if (e.target.closest('.product-media-modal__toggle')) {
//         window.__allowModalClose = true;
//       }
//     },
//     true
//   );
// })();